const { Globals } = require('commons');

module.exports = Globals;



// WEBPACK FOOTER //
// ./src/utils/Globals.js